import type {
  ConfigurationModuleResourceListBffResponseV2Api,
  SearchFieldListResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';
import { toIsoStringIfDate } from '../utils/date.utils';
import type { ConfigurationModulesList } from '../../models/configurationModules.model';
import { SoftwareVersionTypeEnum } from '../../models/configurationModules.model';
import type { SelectItems } from '../../models/selectItems.model';

export function mapModulesList({
  data,
  ...rest
}: ConfigurationModuleResourceListBffResponseV2Api): ConfigurationModulesList {
  return {
    ...rest,
    data: data.map(
      ({ id, name, softwareVersion, parameterSets, createdBy, creationDate, description, updatedBy, updatedDate }) => ({
        id,
        name,
        description,
        parameters: parameterSets?.map(({ id: parameterSetId }) => ({ parameterSetId })),
        softwareVersion: {
          id: softwareVersion.id,
          type: SoftwareVersionTypeEnum[softwareVersion.type],
          name: softwareVersion.softwareName,
          version: softwareVersion.softwareVersionNumber,
        },
        createdBy,
        creationDate: toIsoStringIfDate(creationDate),
        updatedBy,
        updatedDate: toIsoStringIfDate(updatedDate),
      }),
    ),
  };
}

export function mapConfigurationModuleResourceListBffResponseV2ToSelectItems({
  data,
}: ConfigurationModuleResourceListBffResponseV2Api): SelectItems[] {
  return data.map(({ id, name }) => ({ id, label: name }));
}

export function mapConfigurationModulesMinimalListToFieldConfiguration(
  response: SearchFieldListResponseApi,
): FieldConfiguration[] {
  return response.map(({ key, type }) => ({
    key,
    type,
    visible: true,
    searchable: !key.includes('parent'),
  })) as FieldConfiguration[];
}
